import ForgotPasswordForm from "../components/ForgotPassword";

export default ForgotPasswordForm;
